import React from "react";
import id from "@irati/utils/id";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { H2 } from "../Headings";
import { Label2 as Label } from "../Labels";
import Anchor from "../Link/styled/Anchor";
import Http403Svg from "./Http403.svg";
import { ErrorImg, ErrorWrapper } from "./styled/Http403";
var Http403 = function (props) {
    var idNamespace = id("Http403", props);
    return (React.createElement("div", { id: idNamespace },
        React.createElement(ErrorWrapper, { id: id("wrapper", idNamespace), direction: "column", justifyContent: "center", alignItems: "center" },
            React.createElement(ErrorImg, { src: Http403Svg, alt: "Error" }),
            React.createElement(H2, { id: id("title", idNamespace) },
                React.createElement(FormattedMessage, { id: "platform.http403.error.header" })),
            React.createElement(Label, { id: id("subtitle", idNamespace) },
                React.createElement(FormattedMessage, { id: "platform.http403.error.subtitle", values: {
                        url: (React.createElement(Anchor, { href: props.formatMessage({ id: "platform.http403.error.pbHref" }), target: "_BLANK" },
                            React.createElement(FormattedMessage, { id: "platform.http403.error.href.text" })))
                    } })))));
};
Http403.defaultProps = {
    id: "http-403"
};
export default injectIntl(Http403);
